export enum SearchType {

    OPPORTUNITIES = "OPPORTUNITIES",
    AWARDS = "AWARDS",
    SEARCH = "SEARCH",
    SHORTLIST = "SHORTLIST",
    FRAMEWORKS = "FRAMEWORKS",
    DUMMY = "DUMMY",
    DETAILS_PAGE_ADDENDA = "DETAILS_PAGE_ADDENDA",
}